export const appConfig = {
  version: injectedEnv.REACT_APP_VERSION,
  environment: import.meta.env.PROD ? 'production' : 'development',
  isDev: import.meta.env.DEV,
  i18n: {
    debug: injectedEnv.REACT_APP_I18N_DEBUG === 'true',
  },
  oidc: {
    debug: injectedEnv.REACT_APP_OIDC_DEBUG === 'true',
  },
  mui: {
    license:
      '9f4fa10470bd9125020bd958b0844d23Tz0xMjU1MzUsRT0xODAyMzkwMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
  },
  agGrid: {
    license: injectedEnv.REACT_APP_AG_GRID_LICENSE,
  },
  mapbox: {
    token: injectedEnv.REACT_APP_MAPBOX_TOKEN,
  },
  location: {
    apiKey: injectedEnv.REACT_APP_LOCATION_API_KEY,
  },
  hubble: {
    enabled: !!injectedEnv.REACT_APP_HUBBLE_WEBSITE_ID,
    scriptDomain: injectedEnv.REACT_APP_HUBBLE_SCRIPT_DOMAIN,
    websiteId: injectedEnv.REACT_APP_HUBBLE_WEBSITE_ID,
    domains: injectedEnv.REACT_APP_HUBBLE_DOMAINS ? injectedEnv.REACT_APP_HUBBLE_DOMAINS.split(',') : undefined,
  },
  keycloak: {
    url: injectedEnv.REACT_APP_KEYCLOAK_URL as string,
    realm: injectedEnv.REACT_APP_KEYCLOAK_REALM as string,
    clientId: injectedEnv.REACT_APP_KEYCLOAK_CLIENT_ID as string,
  },
  cube: {
    url: injectedEnv.REACT_APP_CUBE_URL,
  },
  curiosity: {
    url: injectedEnv.REACT_APP_CURIOSITY_URL,
  },
  falcon: {
    url: injectedEnv.REACT_APP_FALCON_URL,
  },
  sevenbridges: {
    url: injectedEnv.REACT_APP_SEVEN_BRIDGES_URL,
  },
  features: {
    enableMessageSuggestions: injectedEnv.REACT_APP_ENABLE_MESSAGE_SUGGESTIONS === 'true',
  },
  superset: {
    url: injectedEnv.REACT_APP_SUPERSET_URL,
  },
  datagraph: {
    url: injectedEnv.REACT_APP_DATAGRAPH_URL,
  },
  search: {
    url: injectedEnv.REACT_APP_SEARCH_URL,
  },
  aisearch: {
    url: injectedEnv.REACT_APP_AISEARCH_URL,
  },
  http: {
    timeout: Number(injectedEnv.REACT_APP_HTTP_TIMEOUT) || 300_000,
  },
  sentry: {
    enabled: import.meta.env.PROD && !!injectedEnv.REACT_APP_SENTRY_DSN,
    dsn: injectedEnv.REACT_APP_SENTRY_DSN,
    environment: injectedEnv.REACT_APP_SENTRY_ENVIRONMENT,
  },
};
